import {
  Checkbox,
  FormControlLabel,
  Grid,
  SelectChangeEvent,
  Typography,
  useEventCallback,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import DescriptionForm from 'civil-status/components/shared/description-document';
import { transformCertificate } from 'front-office/utils/transform-certificate';
import { transformCertificateTitle } from 'front-office/utils/transform-certificate-title';
import { CertificationFormVM } from 'front-office/view-models/document-birth-form';
import { setNestedObjectValues, useFormikContext } from 'formik';
import ModalInfoCertification from './info-certificate';
import TypePaymentList from 'front-office/components/shared/payment/type-payment';
import { blobToBase64 } from 'shell/utils/base64-to-blob';
// import { DateTime } from 'luxon';
import { memo, useEffect, useMemo, useState, useCallback } from 'react';
import { ModalViewerPDF } from 'shell/components/shared/pdf-modal';
import PmiTextField from 'shell/components/shared/text-field';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
// import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useUserProfile } from 'shell/hooks/use-user-profile';
// import { HttpResponseList } from 'shell/models/http-response';
// import { TypeResidence } from 'shell/models/type-payment';
// import { transformerModalityPayment } from 'shell/utils/transformer-modality-payment';
// import { ModalityPaymentVM } from 'shell/view-models/modality-payment';
// import { Operation } from 'shell/view-models/operation';
import NumberCopiesSelect from './select-copies';
import TimberSelect from './select-timber';
import TimberFreeSelect from './select-timber-free';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { DocumentRegistry } from 'shell/models/document-registry';
import { ItemVM } from 'shell/view-models/item';

interface PrintDocumentPageProps {
  onBack: () => void;
}

const PrintDocumentPage = ({ onBack }: PrintDocumentPageProps): React.ReactElement => {
  const formContext = useFormikContext<CertificationFormVM>();

  const { userProfile } = useUserProfile();

  const isNascita: boolean = useMemo(() => {
    return Boolean(formContext.values.documentChosenBirth);
  }, [formContext.values.documentChosenBirth]);

  const isMorte: boolean = useMemo(() => {
    return Boolean(formContext.values.documentChosenDeath);
  }, [formContext.values.documentChosenDeath]);

  const isMatrimonio: boolean = useMemo(() => {
    return Boolean(formContext.values.documentChosenMarriage);
  }, [formContext.values.documentChosenMarriage]);

  const isUnioneCivile: boolean = useMemo(() => {
    return Boolean(formContext.values.documentChosenCivilUnion);
  }, [formContext.values.documentChosenCivilUnion]);

  const isCittadinanza: boolean = useMemo(() => {
    return Boolean(formContext.values.documentChosenCitizenship);
  }, [formContext.values.documentChosenCitizenship]);

  const lockDocument = useHttpClient('', {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
    },
  });

  const onClickBack = useEventCallback(() => {
    let url = __CIVIL_STATUS_API_URL__;

    if (isNascita) {
      url = `${url}/atti-nascita-sima/blocca-atto`;
    }

    if (isMorte) {
      url = `${url}/atti-morte-sima/blocca-atto`;
    }

    if (isMatrimonio) {
      url = `${url}/atti-matrimonio-sima/blocca-atto`;
    }

    if (isUnioneCivile) {
      url = `${url}/atti-unione-civile-sima/blocca-atto`;
    }

    if (isCittadinanza) {
      url = `${url}/atti-cittadinanza-sima/blocca-atto`;
    }

    (
      lockDocument({
        url,
        data: {
          key: {
            anno: formContext.values.chosenDocument?.year,
            numeroRegistro: formContext.values.chosenDocument?.numReg,
            numeroAtto: formContext.values.chosenDocument?.documentNumber,
            parte: formContext.values.chosenDocument?.parte,
            serie1: formContext.values.chosenDocument?.serie,
          },
        },
      }) as ResponsePromise<void>
    ).then(() => {
      onBack();
    });
  });

  const clearPrintDocument = useCallback(() => {
    formContext.setValues({
      ...formContext.values,
      timber: '',
      timberFreeText: '',
      copies: '1',
      reason: '',
      flagFincatura: false,
      flagOmittedSign: false,
      typePayment: '',
    });
  }, [formContext.values, formContext.setValues]);

  const [series] = useHttpFetch<HttpResponseList<DocumentRegistry>, Array<ItemVM>>(
    `${__CIVIL_STATUS_API_URL__}/registro-atto`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
      },
      transformer: (response) =>
        (response?.data?.payload?.list || []).map((item) => ({
          id: item.key?.codiceRegistro || '',
          value: item.registro || '',
        })),
    }
  );

  const seriesData = (series.data as Array<ItemVM>) || [];

  const registryItem = seriesData.find(
    (item) => item.id === formContext.values.chosenDocument?.numReg
  );

  // const [modalityPayment] = useHttpFetch<HttpResponseList<TypeResidence>, Array<ModalityPaymentVM>>(
  //   `${__CERTIFICATION_API_URL__}/certificazione/modalita-rilascio`,
  //   {
  //     onBootstrap: true,
  //     initialData: [],
  //     options: {
  //       params: {},
  //       paramsSerializer: () =>
  //         `filters=today:${DateTime.now().toFormat('yyyy-MM-dd')}:${Operation.EQUALS}`,
  //     },
  //     transformer: (response) =>
  //       (transformerModalityPayment(response) || []).filter(
  //         (item) => item.id === 'PPAA' || item.id === 'STCV'
  //       ),
  //   }
  // );

  // const list = (modalityPayment.data || []) as Array<ModalityPaymentVM>;

  // const paymentSTCV = list.find((item) => item.id === 'STCV');

  // const paymentPPAA = list.find((item) => item.id === 'PPAA');

  const print = useHttpClient<Blob>(`${__CIVIL_STATUS_API_URL__}/stampa`, {
    options: { loading: true, method: 'POST', errorCatching: true, data: {} },
  });

  useEffect(() => {
    return () => {
      clearPrintDocument();
    };
  }, []);

  const [pdfModal, setPdfModal] = useState({ data: '', open: false, name: '', type: '' });

  // InfoCertification modal
  const [infoCertification, setInfoCertification] = useState<{
    open: boolean;
    total?: number;
    type?: string;
  }>({
    open: false,
  });

  const onPrint = useEventCallback(() => {
    formContext.validateForm(formContext.values).then((validationErrors) => {
      formContext.setTouched(setNestedObjectValues(validationErrors, true));

      if (Object.values(validationErrors).length > 0) {
        return;
      }
      const isNotFlagSign = formContext?.values?.flagOmittedSign;
      const nomeOperatore = userProfile?.datiLogin?.nome;

      const data = transformCertificate(
        formContext.values,
        isNotFlagSign,
        nomeOperatore,
        userProfile.datiLogin?.key?.userName || '',
        registryItem
      );

      (
        print({
          data,
          responseType: 'blob',
        }) as ResponsePromise<Blob>
      ).then((response) => {
        if (response?.data) {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          blobToBase64(blob).then((base64) => {
            setPdfModal({
              data: base64.split(',')[1],
              name: 'Certificazione Stato Civile',
              open: true,
              type: data.tipoStampa as string,
            });
          });
        }
      });
    });
  });

  const atto = useMemo(() => {
    return transformCertificateTitle(formContext.values?.certificate);
  }, [formContext.values?.certificate]);

  const handleTypePayment = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('typePayment', event.target.value);
  });

  return (
    <>
      <Typography
        color="secondary.main"
        style={{
          fontSize: '26px',
        }}
      >
        {atto.type} - Stampa {atto.value}
      </Typography>
      <Grid container spacing={2}>
        <Grid item container spacing={2} xs={12} md={4}>
          <DescriptionForm
            values={
              formContext.values.chosenDocument
                ? {
                    ...formContext.values.chosenDocument,
                    portion: formContext.values.chosenDocument?.parte,
                    registerNumber: formContext.values.chosenDocument?.numReg,
                  }
                : undefined
            }
          />
          {!formContext.values.selectedCertificate ? undefined : (
            <>
              <Grid item xs={12}>
                <TimberSelect
                  value={formContext.values.timber || ''}
                  onChange={(value) => formContext.setFieldValue('timber', value)}
                  certificate={formContext.values.selectedCertificate || ''}
                  error={formContext.touched?.timber && Boolean(formContext.errors?.timber)}
                  actType={atto.type?.replaceAll(' ', '')?.toUpperCase()}
                />
              </Grid>
              <Grid item xs={12}>
                <TimberFreeSelect
                  value={formContext.values.timberFreeText || ''}
                  onChange={(value, item) =>
                    formContext.setValues({
                      ...formContext.values,
                      timberFreeText: value,
                      reason: item?.value,
                      modifierCode: item?.itemField?.codiceModificatore,
                    })
                  }
                  error={
                    formContext.touched?.timberFreeText &&
                    Boolean(formContext.errors?.timberFreeText)
                  }
                  actType={atto.type?.replaceAll(' ', '')?.toUpperCase()}
                />
              </Grid>
              <Grid item xs={12}>
                <PmiTextField
                  aria-label="Motivo"
                  label="Motivo"
                  id="reason"
                  name="reason"
                  fullWidth
                  type="text"
                  variant="outlined"
                  multiline
                  rows={3}
                  error={formContext.touched?.reason && Boolean(formContext.errors?.reason)}
                  helperText={formContext.errors?.reason}
                  value={formContext.values.reason || ''}
                  onChange={(event) => formContext.setFieldValue('reason', event?.target.value)}
                />
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <NumberCopiesSelect
              value={formContext.values.copies || ''}
              onChange={(value) => formContext.setFieldValue('copies', value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TypePaymentList
              onChange={handleTypePayment}
              value={formContext.values?.typePayment || ''}
              error={formContext.touched?.typePayment && Boolean(formContext.errors?.typePayment)}
              disabled={formContext.values.flagInternal || false}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  id="flagCarta"
                  checked={formContext.values.flagCarta || false}
                  disabled={formContext.values.flagInternal}
                  onChange={() => {
                    formContext.setFieldValue('flagCarta', !formContext.values.flagCarta);
                  }}
                  inputProps={{ 'aria-label': 'carta zero' }}
                />
              }
              label="Carta zero"
            />
            <FormControlLabel
              control={
                <Checkbox
                  id="flagOmittedSign"
                  //disabled={formContext.values.flagInternal || isDisabled}
                  checked={formContext.values.flagOmittedSign || false}
                  onChange={() => {
                    formContext.setFieldValue(
                      'flagOmittedSign',
                      !formContext.values.flagOmittedSign
                    );
                  }}
                  inputProps={{ 'aria-label': 'stampa firma omessa' }}
                />
              }
              label="Stampa firma omessa"
            />
            <FormControlLabel
              control={
                <Checkbox
                  id="flagFincatura"
                  checked={formContext.values.flagFincatura || false}
                  onChange={() => {
                    formContext.setFieldValue('flagFincatura', !formContext.values.flagFincatura);
                  }}
                  inputProps={{ 'aria-label': 'stampa fincatura' }}
                />
              }
              label="Stampa fincatura"
            />
          </Grid>
        </Grid>
        {formContext.values.flagInternal ? undefined : (
          <Grid item container xs={12} md={8}>
            <Grid item xs={12}>
              <Typography
                color="cdmBrandThird.main"
                style={{
                  fontSize: '26px',
                }}
              >
                Richiedente
              </Typography>
              {formContext.values.matricola ? (
                <div className="pmi-pt-3">
                  <span>Matricola:</span>
                  <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-2">
                    {formContext.values.matricola || ''}
                  </span>
                </div>
              ) : undefined}
              {formContext.values.fiscalCode ? (
                <div className="pmi-pt-3">
                  <span>Cod. Fiscale:</span>
                  <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-2">
                    {formContext.values.fiscalCode || ''}
                  </span>
                </div>
              ) : undefined}
              {formContext.values.documentNumber ? (
                <div className="pmi-pt-1">
                  <span>Doc. Riconoscimento:</span>
                  <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-2">
                    {formContext.values?.documentNumber || ''}
                  </span>
                </div>
              ) : undefined}
              {formContext.values.surname ? (
                <div className="pmi-pt-1">
                  <span>Cognome:</span>
                  <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-2">
                    {formContext.values.surname || ''}
                  </span>
                </div>
              ) : undefined}
              {formContext.values.name ? (
                <div className="pmi-pt-1">
                  <span>Nome:</span>
                  <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-2">
                    {formContext.values.name || ''}
                  </span>
                </div>
              ) : undefined}
              {formContext.values?.birthDate ? (
                <div className="pmi-pt-1">
                  <span>Nato il:</span>
                  <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-2">
                    {formContext.values?.birthDate?.toFormat('dd/MM/yyyy') || ''}
                  </span>
                </div>
              ) : undefined}
              {formContext.values.municipality?.description ||
              formContext.values.foreignMunicipality?.description ? (
                <div className="pmi-pt-1">
                  <span>Nato a:</span>
                  <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-2">
                    {formContext.values.municipality?.description ||
                      formContext.values.foreignMunicipality?.description ||
                      ''}
                  </span>
                </div>
              ) : undefined}
            </Grid>
          </Grid>
        )}
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6} display="flex">
          <div>
            <PmiButton variant="outlined" color="secondary" onClick={() => onClickBack()}>
              Indietro
            </PmiButton>
          </div>
          <div className="pmi-pl-3">
            <PmiButton variant="contained" color="cdmBrandThird" onClick={onPrint}>
              Stampa
            </PmiButton>
          </div>
        </Grid>
      </Grid>
      <ModalViewerPDF
        open={pdfModal.open}
        data={pdfModal.data}
        name={pdfModal.name}
        title="Certificazione Stato Civile"
        onClose={() => {
          // const parsedTotal = formContext.values.flagInternal
          //   ? paymentPPAA?.amountRightsCivilState
          //   : paymentSTCV?.amountRightsCivilState;

          setInfoCertification({ open: true, total: 0, type: pdfModal.type });

          setPdfModal({ data: '', open: false, name: '', type: '' });
        }}
      />
      <ModalInfoCertification
        open={infoCertification.open}
        onClose={() => setInfoCertification({ open: false })}
        title={`${atto.type} ${atto.value}`}
        amountCertifate={infoCertification.total?.toFixed(2)}
      />
    </>
  );
};

PrintDocumentPage.displayName = 'Print Document Page';

const PrintDocument = memo(PrintDocumentPage);

export default PrintDocument;
